import { render, staticRenderFns } from "./materialSel.vue?vue&type=template&id=3a36ad64&scoped=true&"
import script from "./materialSel.vue?vue&type=script&lang=js&"
export * from "./materialSel.vue?vue&type=script&lang=js&"
import style0 from "./materialSel.vue?vue&type=style&index=0&id=3a36ad64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a36ad64",
  null
  
)

export default component.exports